// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./App.css";
import "./index.css";
import { MeProvider } from "./contexts/MeContext";

/**
 * ---- グローバル背景（既存のまま維持） -------------------------
 */
function setGlobalBackground(): void {
  const body = document.body;
  if (!body) return;
  body.style.backgroundImage = "url(/assets/member/boatOKUman_LP_LP-29_haikei.webp)";
  body.style.backgroundRepeat = "repeat-y";
  body.style.backgroundPosition = "center top";
  body.style.backgroundSize = "100% auto";
  body.style.backgroundAttachment = "fixed";
  body.style.backgroundColor = "#eaf3f7";
  (body.style as any).webkitFontSmoothing = "antialiased";
  (body.style as any).MozOsxFontSmoothing = "grayscale";
}
setGlobalBackground();

// React 18 ルート描画
const rootEl = document.getElementById("root") as HTMLElement;
if (!rootEl) {
  throw new Error("#root が見つかりません。public/index.html を確認してください。");
}

ReactDOM.createRoot(rootEl).render(
  <BrowserRouter>
    <MeProvider>
      <App />
    </MeProvider>
  </BrowserRouter>
);
